// Super basic email validation
export const isValidEmail = (emailToTest: string): boolean => {
  // Check for spaces anywhere in the email
  if (emailToTest.includes(' ')) return false

  // Check for multiple @ symbols (should have exactly one)
  if ((emailToTest.match(/@/g) || []).length !== 1) return false

  const atPos = emailToTest.indexOf('@')
  const dotPos = emailToTest.lastIndexOf('.')

  // Check @ exists and is not at start
  if (atPos <= 0) return false

  // Check what comes before @ (email can't start with a dot)
  if (emailToTest[0] === '.') return false

  // Check for dot immediately after @
  if (emailToTest[atPos + 1] === '.') return false

  // Check there's content between @ and last dot
  if (dotPos - atPos <= 1) return false

  // Check email doesn't end with dot
  if (dotPos === emailToTest.length - 1) return false

  return true
}
